import React from 'react';
import StatusIcon from 'src/components/StatusIcon';
import CardMovementStatus from './constants/card-movements';
import { IconStatusAndColor } from './constants/common';

const getCardMovementStatusIcon = status => {
  switch (status) {
    case CardMovementStatus.SUCCEEDED:
      return (
        <StatusIcon
          description="ENUMS.DOCUMENT_STATUS.SUCCEEDED"
          type={IconStatusAndColor.OK.status}
        />
      );
    case CardMovementStatus.FAILED:
      return (
        <StatusIcon
          description="ENUMS.DOCUMENT_STATUS.FAILED"
          type={IconStatusAndColor.ERROR.status}
        />
      );
    case CardMovementStatus.PENDING:
      return (
        <StatusIcon
          description="ENUMS.DOCUMENT_STATUS.IS_PENDING"
          type={IconStatusAndColor.WARNING.status}
        />
      );
    default:
      return (
        <StatusIcon
          description="COMMON.NO_DATA"
          type={IconStatusAndColor.NONE.status}
        />
      );
  }
};

export default getCardMovementStatusIcon;
